import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostCamp from "./postCamp";
import {
  addPostCamp,
  } from "services/redux/brandActivtion/conductCamp/action"

const mapStateToProps = (state) => ({
    postCampRes: state.ConductCampReducer.postCampRes,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    addPostCamp,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostCamp);
